import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServerUrlService } from './server-url.service';

@Injectable({
  providedIn: 'root'
})
export class EmpresasService {

  constructor(
    private http: HttpClient,
    private serverUrlService: ServerUrlService
  ) { }

  getEmpresas() {
    return this.http.get(`${this.serverUrlService.getUrl()}/empresas`)
  }
}
